import { render } from "./LoyaltySettings.vue?vue&type=template&id=473ac725"
import script from "./LoyaltySettings.vue?vue&type=script&lang=js"
export * from "./LoyaltySettings.vue?vue&type=script&lang=js"

import "./LoyaltySettings.vue?vue&type=style&index=0&id=473ac725&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__